<template>
  <v-row>
    <v-col cols="5">
      <!-- 仕入先名 -->
      <SelectStorageName
        v-model="inputedValue.ship"
        cols="12"
        :hasDefault="false"
      />
    </v-col>
    <v-col cols="7">
      <v-row no-gutters>
        <v-col cols="4" class="originalCenter"
          >{{ $t('loading.loading_loading-storage') }}
        </v-col>
        <v-col cols="8">
          <!-- 通貨 -->
          <SelectStorageName
            v-model="inputedValue.loading"
            :hasDefault="false"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { SelectStorageName } from '@/components/items/Selectboxes'

export default {
  components: {
    SelectStorageName
  },
  props: {
    value: {}
  },
  data: () => ({
    items: []
  }),
  created() {
    //
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
